import { createVNode, nextTick, render } from "vue";

let dialogAppContext;

export const cache = new Set();

export function setDialogAppContext(context) {
  dialogAppContext = context;
}

export function openDialog(component) {
  return (propsData = {}, parent = undefined) => new Promise((resolve, reject) => {
    const parentInstance = parent && parent.$;
    const appContext = parentInstance ? parentInstance.appContext : dialogAppContext;
    if (!appContext) {
      reject(new Error("Call setDialogAppContext(app._context) before opening a dialog."));
      return;
    }

    const container = document.createElement("div");
    let instance;
    let closing = false;
    let settled = false;
    let stopWatching;
    let closeTimer;

    const cleanup = () => {
      clearTimeout(closeTimer);
      if (stopWatching) stopWatching();
      try {
        render(null, container);
      } finally {
        instance = null;
        cache.delete(container);
        container.remove();
      }
    };

    const destroyDialog = () => {
      if (closing) return;
      closing = true;
      cache.add(container);
      if (instance && instance.visible !== undefined) instance.visible = false;
      closeTimer = setTimeout(cleanup, 1000);
    };

    const settle = (callback, data) => {
      if (settled) return;
      settled = true;
      destroyDialog();
      callback(data);
    };

    const vnode = createVNode(component, {
      ...propsData,
      onDoneOnce: data => settle(resolve, data),
      onCancelOnce: data => settle(reject, data),
    });
    vnode.appContext = parentInstance
      ? { ...appContext, provides: parentInstance.provides }
      : appContext;

    try {
      document.body.appendChild(container);
      render(vnode, container);
      instance = vnode.component.proxy;
      if (instance.visible !== undefined) {
        stopWatching = instance.$watch("visible", visible => {
          if (!visible) destroyDialog();
        });
        if (closing) instance.visible = false;
        nextTick(() => {
          if (instance && !closing) instance.visible = true;
        });
      }
    } catch (error) {
      cleanup();
      reject(error);
    }
  });
}
